import script from "./SheetMorgage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetMorgage.vue?vue&type=script&setup=true&lang=ts"

import "./SheetMorgage.vue?vue&type=style&index=0&id=01c4510a&lang=css"

const __exports__ = script;

export default __exports__